import React, { useState, useEffect } from "react";
import ModalForms from "../component/ModalForms"
import ProgressCircle from "../component/progresscircle";

function Expenses() {
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [activeModal, setActiveModal] = useState(null);
  const [expensesdata, setExpensesdata] = useState([]);

  // ✅ Dummy Data
  useEffect(() => {
    const dummy = [
      {
        _id: 1,
        itemName: "Laptop",
        location: "Delhi",
        purchaseByName: "Rahul Sharma",
        purchaseDate: "2026-03-10",
        qty: 1,
        amount: 55000,
        status: "Approved",
      },
      {
        _id: 2,
        itemName: "Office Chair",
        location: "Noida",
        purchaseByName: "Amit Kumar",
        purchaseDate: "2026-03-12",
        qty: 2,
        amount: 8000,
        status: "Pending",
      },
      {
        _id: 3,
        itemName: "Mouse",
        location: "Ghaziabad",
        purchaseByName: "Sneha Gupta",
        purchaseDate: "2026-03-14",
        qty: 3,
        amount: 1500,
        status: "Rejected",
      },
    ];

    setExpensesdata(dummy);
  }, []);

  // Edit
  const handleEdit = (expense) => {
    setEditId(expense._id);
    setEditForm({
      itemName: expense.itemName,
      location: expense.location,
      purchaseByName: expense.purchaseByName,
      purchaseDate: expense.purchaseDate,
      qty: expense.qty,
      amount: expense.amount,
      status: expense.status,
    });
  };

  const handleCancel = () => {
    setEditId(null);
    setEditForm({});
  };

  const handleSave = (id) => {
    const updated = expensesdata.map((e) =>
      e._id === id ? { ...e, ...editForm } : e
    );

    setExpensesdata(updated);
    setEditId(null);
    setEditForm({});
  };

  // Delete
  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this expense?"))
      return;

    setExpensesdata(expensesdata.filter((e) => e._id !== id));
  };

  return (
    <>
      <div className="page-header-tap">
        <h3>Expenses</h3>

        <div>
          <select className="select">
            <option>Export Excel</option>
            <option>Download PDF</option>
          </select>

          <button
            onClick={() => setActiveModal("addexpenses")}
            className="addbtn"
          >
            + Add Expenses
          </button>

           <ModalForms
            activeModal={activeModal}
            openModal={setActiveModal}
            closeModal={() => setActiveModal(null)}
          /> 
        </div>
      </div>

      <div className="counter-boxed-div">
        <ProgressCircle complete={3} full={10} label="Total Expenses" />
        <ProgressCircle complete={1} full={10} label="Approved" />
        <ProgressCircle complete={1} full={10} label="Pending" />
        <ProgressCircle complete={1} full={10} label="Rejected" />
      </div>

      <div className="table-div" style={{ marginTop: "20px" }}>
        <div className="table-header">
          <h5>Expenses list</h5>

          <select className="filterselect">
            <option>All</option>
            <option>Jan</option>
            <option>Feb</option>
            <option>Mar</option>
          </select>
        </div>

        <div className="table">
          <table>
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Location</th>
                <th>Purchase By</th>
                <th>Purchase Date</th>
                <th>Qty</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {expensesdata.map((e) => (
                <tr key={e._id}>
                  <td>
                    {editId === e._id ? (
                      <input
                        value={editForm.itemName}
                        onChange={(ev) =>
                          setEditForm({
                            ...editForm,
                            itemName: ev.target.value,
                          })
                        }
                      />
                    ) : (
                      e.itemName
                    )}
                  </td>

                  <td>
                    {editId === e._id ? (
                      <input
                        value={editForm.location}
                        onChange={(ev) =>
                          setEditForm({
                            ...editForm,
                            location: ev.target.value,
                          })
                        }
                      />
                    ) : (
                      e.location
                    )}
                  </td>

                  <td>
                    {editId === e._id ? (
                      <input
                        value={editForm.purchaseByName}
                        onChange={(ev) =>
                          setEditForm({
                            ...editForm,
                            purchaseByName: ev.target.value,
                          })
                        }
                      />
                    ) : (
                      e.purchaseByName
                    )}
                  </td>

                  <td>
                    {editId === e._id ? (
                      <input
                        type="date"
                        value={editForm.purchaseDate}
                        onChange={(ev) =>
                          setEditForm({
                            ...editForm,
                            purchaseDate: ev.target.value,
                          })
                        }
                      />
                    ) : (
                      new Date(e.purchaseDate).toLocaleDateString()
                    )}
                  </td>

                  <td>
                    {editId === e._id ? (
                      <input
                        type="number"
                        value={editForm.qty}
                        onChange={(ev) =>
                          setEditForm({
                            ...editForm,
                            qty: ev.target.value,
                          })
                        }
                      />
                    ) : (
                      e.qty
                    )}
                  </td>

                  <td>
                    {editId === e._id ? (
                      <input
                        type="number"
                        value={editForm.amount}
                        onChange={(ev) =>
                          setEditForm({
                            ...editForm,
                            amount: ev.target.value,
                          })
                        }
                      />
                    ) : (
                      `₹ ${e.amount}`
                    )}
                  </td>

                  <td>
                    {editId === e._id ? (
                      <select
                        value={editForm.status}
                        onChange={(ev) =>
                          setEditForm({
                            ...editForm,
                            status: ev.target.value,
                          })
                        }
                      >
                        <option value="Approved">Approved</option>
                        <option value="Pending">Pending</option>
                        <option value="Rejected">Rejected</option>
                      </select>
                    ) : (
                      <span className="statusbox green-bg">
                        {e.status}
                      </span>
                    )}
                  </td>

                  <td>
                    {editId === e._id ? (
                      <>
                        <button
                          onClick={() => handleSave(e._id)}
                          className="statusbox green-bg"
                        >
                          Save
                        </button>

                        <button
                          onClick={handleCancel}
                          className="statusbox red-bg"
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => handleEdit(e)}
                          className="statusbox green-bg"
                        >
                          Edit
                        </button>

                        <button
                          onClick={() => handleDelete(e._id)}
                          className="statusbox red-bg"
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
    </>
  );
}

export default Expenses;